<template>
  <nav class="top">
    <button class="previous" @click="reset" v-if="showFinish">
      <svg width="14" height="24" viewBox="0 0 14 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 22L2 12L12 2" stroke="#241F21" stroke-opacity="0.5" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/></svg> <span class="btn_text">Reset</span>
    </button>
    <div class="spacer top" v-else></div>
    <div class="text">
      <h1>{{ title }}</h1>
      <h2 v-if="subtitle">{{ subtitle }}</h2>
    </div>
    <button class="close" @click="close">
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.559099 0.559099C0.917199 0.201108 1.40282 0 1.90917 0C2.41553 0 2.90115 0.201108 3.25925 0.559099L10.0115 7.31138L16.7638 0.559099C17.124 0.211254 17.6063 0.0187787 18.107 0.0231296C18.6077 0.0274804 19.0866 0.228309 19.4407 0.582361C19.7947 0.936413 19.9956 1.41536 19.9999 1.91605C20.0043 2.41673 19.8118 2.8991 19.464 3.25925L12.7117 10.0115L19.464 16.7638C19.8118 17.124 20.0043 17.6063 19.9999 18.107C19.9956 18.6077 19.7947 19.0866 19.4407 19.4407C19.0866 19.7947 18.6077 19.9956 18.107 19.9999C17.6063 20.0043 17.124 19.8118 16.7638 19.464L10.0115 12.7117L3.25925 19.464C2.8991 19.8118 2.41673 20.0043 1.91605 19.9999C1.41536 19.9956 0.936413 19.7947 0.582361 19.4407C0.228309 19.0866 0.0274804 18.6077 0.0231296 18.107C0.0187787 17.6063 0.211254 17.124 0.559099 16.7638L7.31138 10.0115L0.559099 3.25925C0.201108 2.90115 0 2.41553 0 1.90917C0 1.40282 0.201108 0.917199 0.559099 0.559099Z" fill="white"/></svg>
    </button>
  </nav>
</template>
<script>
import { mapState } from 'vuex'

export default {
  props: {
    title: {
      type: String
    },
    subtitle: {
      type: String
    },
    step: {
      required: true
    }
  },
  computed: mapState({
    isModal: state => state.isModal,
    showFinish () {
      return parseInt(this.step) === 8
    }
  }),
  methods: {
    previous () {
      if (parseInt(this.step) === 1) {
        this.$router.push('/')
        return
      }
      this.$router.push('/step/' + (this.step - 1))
    },
    close () {
      this.$store.commit('hideModal')
      this.$router.push('/')
    },
    reset () {
      this.$router.push('/')
    }
  }
}
</script>
<style lang="scss">
@import "./../assets/scss/variables";
@import "./../assets/scss/mixins";

#ec-steps {
  position: relative;

  nav.top {
    width: 100%;
    padding: 1rem;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 1rem;

    .close {
      svg path {
        fill: rgba($dark, 0.5);
      }
    }

    h1 {
      color: $sol_black;
      font-family: $font-family-din-medium;
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 24px;
      text-align: center;
      letter-spacing: 1px;
      margin: 0;
      max-width: 804px;

      @include respond-above(lg) {
        font-size: 28px;
        line-height: 46px;
        font-weight: 500;
      }
    }

    h2 {
      color: $dark;
      font-family: $font-family-sans;
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 1.4;
      text-align: center;
      letter-spacing: 1px;
      margin: 1rem auto 0 auto;
      max-width: 804px;
      display: none;

      @include respond-above(lg) {
        display: block;
      }
    }

    .text {
      padding: 0 1rem;

      @include respond-above(lg) {
       // padding-top: 0;
      }
    }

    button {
      padding: 10px;
      align-items: flex-start;
      gap: 10px;
      color: #000;

      @include respond-above(lg) {
        align-items: center;
      }

      &.previous {
        svg {
          path {
            // stroke: white;
            stroke: rgba(35, 30, 33, 0.5);
            stroke-opacity: 1;
          }
        }

        &:hover {
          svg {
            path {
              stroke: #231e21;
            }
          }

        }
      }

      .btn_text {
        display: none;
        font-size: 16px;
        color: #414345;

        @include respond-above(lg) {
          display: inline-block;
        }
      }
    }
  }
}
</style>
